<mat-nav-list class="custom-menu">

  <mat-divider></mat-divider>
  
  <!-- EMPRESAS -->
  @if(isSuperAdmin()){
    <mat-list>
      <!--h3 mat-subheader>Empresas</h3-->
      <mat-list-item (click)="goToCompanies()" [ngClass]="{ 'active': menuCode === 'companies' || menuCode === 'companiesAdd' }">
        <mat-icon matListItemIcon>business</mat-icon>
        <div matListItemTitle>Lista Empresas</div>
        <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'companiesAdd' }"
          (click)="goToNewCompany(); $event.stopPropagation()" matTooltip="Agregar Empresa">
          <mat-icon color="primary">add</mat-icon>
        </button>
      </mat-list-item>
    </mat-list>
    <mat-divider></mat-divider>
  }
  <!-- ADMINISTRACION EMPRESA -->
  @if(isAdmin()){
    <mat-list>
      <!--h3 mat-subheader>Admin Empresa</h3-->
      <mat-list-item (click)="goToAdminCompany()" [ngClass]="{ 'active': menuCode === 'adminCompany'  }">
        <mat-icon matListItemIcon>business</mat-icon>
        <div matListItemTitle>Admin Empresa</div>
      </mat-list-item>
    </mat-list>
    <mat-divider></mat-divider>
    }
  <!-- USUARIOS -->
  @if(isAdmin() || isSuperAdmin()){
  <mat-list>
    <!--h3 mat-subheader>Usuarios</h3-->
    <mat-list-item (click)="goToUsers()" [ngClass]="{ 'active': menuCode === 'users' || menuCode === 'usersAdd' }">
      <mat-icon matListItemIcon>people</mat-icon>
      <div matListItemTitle>Usuarios</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'usersAdd' }"
        (click)="goToNewUser(); $event.stopPropagation()" matTooltip="Agregar Usuario">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>
  </mat-list>
  <mat-divider></mat-divider>
  }
  <!-- OFERTAS LABORALES -->
  @if(isUser() || isAdmin()){
  <mat-list>
    <!--h3 mat-subheader>Ofertas Laborales</h3-->
    <mat-list-item (click)="goToListOffer()" [ngClass]="{ 'active': menuCode === 'offers' || menuCode === 'offersAdd' }">
      <mat-icon matListItemIcon>work_outline</mat-icon>
      <div matListItemTitle>Ofertas Laborales</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'offersAdd' }"
        (click)="goToNewOffer(); $event.stopPropagation()" matTooltip="Ofertas Laborales">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>
  </mat-list>
  <mat-divider></mat-divider>
  <!-- EMPLEADOS -->
  <mat-list>
    <!--<h3 mat-subheader>Empleados</h3-->
    <mat-list-item (click)="goToListEmployee()" [ngClass]="{ 'active': menuCode === 'listEmployee' }">
      <mat-icon matListIcon>badge</mat-icon>
      <span matLine>Lista Empleados</span>
    </mat-list-item>
    <mat-list-item (click)="goToUploadEmployee()" [ngClass]="{ 'active': menuCode === 'uploadEmployee' }">
      <mat-icon matListIcon>cloud_upload</mat-icon>
      <span matLine>Carga Empleados</span>
    </mat-list-item>
    <mat-list-item (click)="goToBudgetCalculation()" [ngClass]="{ 'active': menuCode === 'budgetCalculation' }">
      <mat-icon matListIcon>cloud_upload</mat-icon>
      <span matLine>Calculo Presupuesto</span>
    </mat-list-item>
  </mat-list>
  <mat-divider></mat-divider>
  } 
  @if(isAuthorizer()){
    <!-- Firmas -->
    <mat-list>
      <!--h3 mat-subheader>Firmas Solicitadas</h3-->
      <mat-list-item (click)="goToListRequestedSignatures()" [ngClass]="{ 'active': menuCode === 'listRequestedSignatures' }">
        <mat-icon matListIcon>edit_note</mat-icon>
        <span matLine>Firmas Solicitadas</span>
      </mat-list-item>
    </mat-list>
    <mat-divider></mat-divider>
  }
  <!-- CATÁLOGOS -->
  @if(isAdmin()){
  <mat-list>
    <h3 mat-subheader>Cat&aacute;logos</h3>
    
    
    <mat-list-item (click)="goToListAreas()" [ngClass]="{ 'active': menuCode === 'listAreas' || menuCode === 'addArea' }">
      <mat-icon matListItemIcon>business</mat-icon>
      <div matListItemTitle>&Aacute;reas</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'addArea' }"
        (click)="addArea(); $event.stopPropagation()" matTooltip="Agregar Area">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>

    <mat-list-item (click)="goToListBenefitCatalog()" [ngClass]="{ 'active': menuCode === 'listBenefitCatalog' || menuCode === 'benefitCatalogAdd' }">
      <mat-icon matListItemIcon>volunteer_activism</mat-icon>
      <div matListItemTitle>Beneficios Catalogo</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'benefitCatalogAdd' }"
        (click)="addBenefitCatalog(); $event.stopPropagation()" matTooltip="Agregar beneficio">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>

    <mat-list-item (click)="goToListCostsPerEmployeeCatalog()" [ngClass]="{ 'active': menuCode === 'listCostsPerEmployeeCatalog' || menuCode === 'costsPerEmployeeCatalogAdd' }">
      <mat-icon matListItemIcon>payments</mat-icon>
      <div matListItemTitle>Costos por Empleado Catalogo</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'costsPerEmployeeCatalogAdd' }"
        (click)="addCostsPerEmployeeCatalog(); $event.stopPropagation()" matTooltip="Agregar Costo Empleado">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>

    <mat-list-item (click)="goToListDivisions()" [ngClass]="{ 'active': menuCode === 'listDivisions' || menuCode === 'addDivision' }">
      <mat-icon matListItemIcon>apartment</mat-icon>
      <div matListItemTitle>Divisiones</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'addDivision' }"
        (click)="addDivision(); $event.stopPropagation()" matTooltip="Agregar beneficio">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>

    <mat-list-item (click)="goToListObjectCatalog()" [ngClass]="{ 'active': menuCode === 'listObjectCatalog' || menuCode === 'objectCatalogAdd' }">
      <mat-icon matListItemIcon>data_object</mat-icon>
      <div matListItemTitle>Objectos Catalogo</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'objectCatalogAdd' }"
        (click)="addObjectCatalog(); $event.stopPropagation()" matTooltip="Agregar Objecto">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>

    <mat-list-item (click)="goToListPositions()" [ngClass]="{ 'active': menuCode === 'listPositions' }">
      <mat-icon matListIcon>assignment_ind</mat-icon>
      <span matLine>Posiciones</span>
    </mat-list-item>

    <mat-list-item (click)="goToListWithholdingCatalog()" [ngClass]="{ 'active': menuCode === 'listWithholdingCatalog' || menuCode === 'withholdingCatalogAdd' }">
      <mat-icon matListItemIcon>money_off</mat-icon>
      <div matListItemTitle>Retenciones Catalogo</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'withholdingCatalogAdd' }"
        (click)="addWithholdingCatalog(); $event.stopPropagation()" matTooltip="Agregar Retencion">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>
    <mat-list-item (click)="goToListVariableCatalog()" [ngClass]="{ 'active': menuCode === 'listVariableCatalog' || menuCode === 'variableCatalogAdd' }">
      <mat-icon matListItemIcon>tune</mat-icon>
      <div matListItemTitle>Variables Catalogo</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'variableCatalogAdd' }"
        (click)="addVariableCatalog(); $event.stopPropagation()" matTooltip="Agregar Variable">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>

  </mat-list>
  <mat-divider></mat-divider>
  <!-- LISTADO CONFIGURACIÓN -->
  <mat-list>
    <h3 mat-subheader>Grupos de Configuración</h3>
    
    <mat-list-item (click)="goToListBenefetis()" [ngClass]="{ 'active': menuCode === 'benefetisGroup' || menuCode === 'benefetisGroupAdd' }">
      <mat-icon matListItemIcon>volunteer_activism</mat-icon>
      <div matListItemTitle>Grupos Beneficios</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'benefetisGroupAdd' }"
        (click)="addBenefitsGroup(); $event.stopPropagation()" matTooltip="Agregar beneficios">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>
    <mat-list-item (click)="goToListcostsPerEmployeeGroup()" [ngClass]="{ 'active': menuCode === 'costsPerEmployeeGroup' || menuCode === 'costsPerEmployeeGroupAdd' }">
      <mat-icon matListItemIcon>payments</mat-icon>
      <div matListItemTitle>Grupos Costo Empleado</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'costsPerEmployeeGroupAdd' }"
        (click)="addcostsPerEmployeeGroup(); $event.stopPropagation()" matTooltip="Crear Grupo Retenciones">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>
    <mat-list-item (click)="goToListSignatures()" [ngClass]="{ 'active': menuCode === 'signaturesGroup' || menuCode === 'signaturesGroupAdd' }">
      <mat-icon matListItemIcon>edit_note</mat-icon>
      <div matListItemTitle>Grupos Firmas</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'signaturesGroupAdd' }"
        (click)="addSignatures(); $event.stopPropagation()" matTooltip="Agregar Firmas">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>
    <mat-list-item (click)="goToListFormulaGroup()" [ngClass]="{ 'active': menuCode === 'formulaGroup' || menuCode === 'formulaGroupAdd' }">
      <mat-icon matListItemIcon>functions</mat-icon>
      <div matListItemTitle>Grupos Formulas</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'formulaGroupAdd' }"
        (click)="addFormulaGroup(); $event.stopPropagation()" matTooltip="Crear Grupo Formulas">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>
    <mat-list-item (click)="goToListWithholdings()" [ngClass]="{ 'active': menuCode === 'withholdingsGroup' || menuCode === 'withholdingsGroupAdd' }">
      <mat-icon matListItemIcon>money_off</mat-icon>
      <div matListItemTitle>Grupos Retenciones</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'withholdingsGroupAdd' }"
        (click)="addWithholdingsGroup(); $event.stopPropagation()" matTooltip="Crear Grupo Retenciones">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>
    <mat-list-item (click)="goToHolidaysGroup()" [ngClass]="{ 'active': menuCode === 'holidaysGroup' || menuCode === 'holidaysGroupAdd' }">
      <mat-icon matListItemIcon>beach_access</mat-icon>
      <div matListItemTitle>Grupos Vacaciones</div>
      <button mat-icon-button matListItemMeta class="small-icon-btn" [ngClass]="{ 'btn-active': menuCode === 'holidaysGroupAdd' }"
        (click)="addHolidaysGroup(); $event.stopPropagation()" matTooltip="Agregar Vacaciones">
        <mat-icon color="primary">add</mat-icon>
      </button>
    </mat-list-item>
    <mat-list-item (click)="goToListParameters()" [ngClass]="{ 'active': menuCode === 'listParameters' }">
      <mat-icon matListItemIcon>tune</mat-icon>
      <div matListItemTitle>Par&aacute;metros</div>
    </mat-list-item>

  </mat-list>
  }

  <mat-divider></mat-divider>
  <!-- LISTADO MANUALES -->
  <mat-list>
    <h3 mat-subheader>Manuales</h3>
    
    <mat-list-item (click)="downloadManualAdmin()" >
      <mat-icon matListItemIcon>volunteer_activism</mat-icon>
      <div matListItemTitle>Administrador</div>
    </mat-list-item>
    
    <mat-list-item (click)="downloadManualUser()" >
      <mat-icon matListItemIcon>volunteer_activism</mat-icon>
      <div matListItemTitle>Usuario</div>
    </mat-list-item>
    
    <mat-list-item (click)="downloadManualSignature()" >
      <mat-icon matListItemIcon>volunteer_activism</mat-icon>
      <div matListItemTitle>Firmante</div>
    </mat-list-item>
    
    <mat-list-item (click)="downloadManualFormulaExample()" >
      <mat-icon matListItemIcon>volunteer_activism</mat-icon>
      <div matListItemTitle>Formulas Ejemplos</div>
    </mat-list-item>

  </mat-list>

  <!--mat-divider></mat-divider-->
</mat-nav-list>